import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section className="bg-background-100 px-4 py-12 md:px-6 md:py-16" aria-label="主题分类">
      <div className="shell">
      <SectionHeading
        eyebrow="Topics"
        title="按主题追瓜"
        desc="五个常驻栏目，覆盖从娱乐圈到情感线的主要讨论方向，进入栏目可查看该方向下的全部爆料。"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {topics.map((topic, index) => (
          <Link
            key={topic.slug}
            to={`/topic/${topic.slug}`}
            className={`group relative block cursor-pointer overflow-hidden rounded-lg ${
              index === 0 ? "sm:col-span-2 lg:col-span-1" : ""
            }`}
          >
            <div className="relative h-52 w-full md:h-56">
              <img
                src={topic.cover}
                alt={`${topic.name}主题封面`}
                title={`${topic.name} - 独家大瓜`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-transparent" />
            </div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <span className="text-[11px] font-label font-bold tracking-[0.2em] text-accent-300 uppercase">
                    {topic.en}
                  </span>
                  <h3 className="font-heading text-xl font-black text-background-50">{topic.name}</h3>
                </div>
                <span className="flex-shrink-0 rounded-full bg-background-50/15 px-3 py-1 text-[11px] font-label font-bold text-background-50 backdrop-blur-sm">
                  {topic.count} 条
                </span>
              </div>
              <p className="mt-2.5 text-xs leading-relaxed text-background-200 line-clamp-2">{topic.desc}</p>
            </div>
          </Link>
        ))}
      </div>
      </div>
    </section>
  );
}